import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const SalesChannelCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Sales channel",
    cell: (row) => {
      return row.salesChannels
        ? row.salesChannels.join(", ")
        : row.stores.join(", ");
    },
  };
